<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Checkbox, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore;
	let checked = settings.reverse_open_close,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res = await postReq(`/device/${device.category}/settings/reverse`, {
			id,
			enable: Number(checked),
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Checkbox class="mb-s" size="m" bind:checked id="checkbox-vgmvl21"
	>{$format('reverse_sensor_open_close', {
		default: 'Reverse open/close logic.',
	})}</Checkbox
>

<Button loading={waitForResponse} size="m" width="full" class="text-uppercase" on:click={save}
	>{$format('button_apply', { default: 'apply' })}</Button
>
